import { SwiperModule } from 'swiper/angular';
import { RouteAnimationShared } from './utils/route-animation-shared';
import { RecipeShared } from './presentation/general/shared/recipe-shared';
import {
  BrowserModule,
  HammerGestureConfig,
  HammerModule,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
  GoogleLoginProvider,
} from 'angularx-social-login';
import { User } from './core/model/user-model';

import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { IosInstallComponent } from './utils/ios-install/ios-install.component';
import { MaterialModule } from './material.modules';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PhoneRegisterComponent } from './presentation/authentication/phone-register/phone-register.component';
import { SubmitButtonComponent } from './presentation/general/submit-button/submit-button.component';
import { ActivationCodeComponent } from './presentation/authentication/activation-code/activation-code.component';
import { RegisterComponent } from './presentation/register/register/register.component';
import { ProgressNavComponent } from './presentation/general/progress-nav/progress-nav.component';
import { CredentialComponent } from './presentation/authentication/components/credential/credential.component';
import { GenderComponent } from './presentation/authentication/components/gender/gender.component';
import { WeightComponent } from './presentation/authentication/components/weight/weight.component';
import { HeightComponent } from './presentation/authentication/components/height/height.component';
import { DietTypeComponent } from './presentation/generate/diet-type/diet-type.component';
import { ButtonComponent } from './presentation/general/button/button.component';
import { GenerateComponent } from './presentation/generate/generate/generate.component';
import { ActivityLevelComponent } from './presentation/authentication/components/activity-level/activity-level.component';
import { VegetarianComponent } from './presentation/authentication/components/vegetarian/vegetarian.component';
import { RadioButtonComponent } from './presentation/general/radio-button/radio-button.component';
import { DiseaseComponent } from './presentation/authentication/components/disease/disease.component';
import { HatedFoodsComponent } from './presentation/authentication/components/hated-foods/hated-foods.component';
import { DifficultyComponent } from './presentation/authentication/components/difficulty/difficulty.component';
import { StartDateComponent } from './presentation/authentication/components/start-date/start-date.component';
import { DateComponent } from './presentation/authentication/components/date/date.component';
import { GenerateOverviewComponent } from './presentation/generate/generate-overview/generate-overview.component';
import { PopupComponent } from './presentation/general/popup/popup.component';

import { TextHelper } from './utils/text-helper';
import { DeviceInfoHelper } from './utils/device-info-helper';
import { ProgressNavShared } from './presentation/general/shared/progress-nav-shared';
import { RadioButtonShared } from './presentation/general/shared/radio-button-shared';
import { SubmitButtonShared } from './presentation/general/shared/submit-button-shared';
import { RegisterShared } from './presentation/general/shared/register-shared';
import { ButtonShared } from './presentation/general/shared/button-shared';
import { PopupShared } from './presentation/general/shared/popup-shared';
import { GenerateShared } from './presentation/general/shared/generate-shared';
import { MainComponent } from './presentation/main/main.component';
import { PlanComponent } from './presentation/plan/plan.component';
import { BatteryComponent } from './presentation/plan/battery/battery.component';
import { WaterComponent } from './presentation/plan/water/water.component';
import { PlanWeightComponent } from './presentation/plan/plan-weight/plan-weight.component';
import { BottomsheetComponent } from './presentation/general/bottomsheet/bottomsheet.component';
import { BottomsheetShared } from './presentation/general/shared/bottomsheet-shared';
import { MealsTableComponent } from './presentation/plan/meals-table/meals-table.component';
import { CheatDayComponent } from './presentation/plan/cheat-day/cheat-day.component';
import { DateHelper } from './utils/date-helper';
import { CalendarComponent } from './presentation/plan/calendar/calendar.component';
import { CalendarShared } from './presentation/general/shared/calendar-shared';
import { MealDetailComponent } from './presentation/plan/meal-detail/meal-detail.component';
import { ChangeMealComponent } from './presentation/plan/change-meal/change-meal.component';
import { PlanShared } from './presentation/general/shared/plan-shared';
import { ProfileComponent } from './presentation/profile/profile.component';
import { ChartsModule } from 'ng2-charts';
import { DietDetailComponent } from './presentation/profile/diet-detail/diet-detail.component';
import { BarChartComponent } from './presentation/profile/bar-chart/bar-chart.component';
import { MainShared } from './presentation/general/shared/main-shared';
import { PlanStatusComponent } from './presentation/plan/plan-status/plan-status.component';
import { ProfileWaterChartComponent } from './presentation/profile/profile-water-chart/profile-water-chart.component';
import { ProfileWeightChartComponent } from './presentation/profile/profile-weight-chart/profile-weight-chart.component';
import { LineChartComponent } from './presentation/profile/line-chart/line-chart.component';
import 'chartjs-plugin-annotation/src/index.js';
import { SettingComponent } from './presentation/setting/setting.component';
import { EditBottomsheetComponent } from './presentation/general/edit-bottomsheet/edit-bottomsheet.component';
import { EditNameComponent } from './presentation/setting/edit-name/edit-name.component';
import { EditGenderComponent } from './presentation/setting/edit-gender/edit-gender.component';
import { EditBirthdateComponent } from './presentation/setting/edit-birthdate/edit-birthdate.component';
import { EditHeightComponent } from './presentation/setting/edit-height/edit-height.component';
import { EditWeightComponent } from './presentation/setting/edit-weight/edit-weight.component';
import { AboutUsComponent } from './presentation/setting/about-us/about-us.component';
import { LoadingComponent } from './presentation/general/loading/loading.component';
import { LoadingShared } from './presentation/general/shared/loading-shared';
import { BlogComponent } from './presentation/blog/blog.component';
import { BlogShared } from './presentation/general/shared/blog-shared';
import { PostComponent } from './presentation/blog/post/post.component';
import { BlogWithTagComponent } from './presentation/blog/blog-with-tag/blog-with-tag.component';
import { BlogSearchComponent } from './presentation/blog/blog-search/blog-search.component';
import { PostDetailComponent } from './presentation/blog/post-detail/post-detail.component';
import { TwoActionPopupComponent } from './presentation/general/two-action-popup/two-action-popup.component';
import { ReportBottomsheetComponent } from './presentation/general/report-bottomsheet/report-bottomsheet.component';
import { BlogProfileComponent } from './presentation/blog/blog-profile/blog-profile.component';
import { IosBottomsheetComponent } from './presentation/general/ios-bottomsheet/ios-bottomsheet.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TabBarShared } from './presentation/general/shared/tab-bar-shared';
import { ShopComponent } from './presentation/shop/shop.component';
import { ShopPurchasePopupComponent } from './presentation/shop/shop-purchase-popup/shop-purchase-popup.component';
import { ShopShared } from './presentation/general/shared/shop-shared';
import { ShopDiscountDialogComponent } from './presentation/shop/shop-discount-dialog/shop-discount-dialog.component';
import { LogoutComponent } from './presentation/setting/logout/logout.component';
import { AuthGuard } from './utils/authGuard';
import { ProfileShared } from './presentation/general/shared/profile-shared';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { EditFoodBottomsheetComponent } from './presentation/plan/edit-food-bottomsheet/edit-food-bottomsheet.component';
import { AddFoodComponent } from './presentation/plan/add-food/add-food.component';
import { AddFoodBottomsheetComponent } from './presentation/plan/add-food-bottomsheet/add-food-bottomsheet.component';
import { MealDetailDialogComponent } from './presentation/plan/meal-detail-dialog/meal-detail-dialog.component';
import { TutorialComponent } from './presentation/general/tutorial/tutorial.component';
import { TutorialShared } from './presentation/general/shared/tutorial-shared';
import { IntroComponent } from './presentation/intro/intro.component';
import { DailyFoodFactComponent } from './presentation/plan/daily-food-fact/daily-food-fact.component';
import { BlogSuggestComponent } from './presentation/blog/blog-suggest/blog-suggest.component';
import { BlogSettingComponent } from './presentation/blog/blog-setting/blog-setting.component';
import { EditBioComponent } from './presentation/blog/edit-bio/edit-bio.component';
import { EditStatusComponent } from './presentation/blog/edit-status/edit-status.component';
import { BlogCreatPostComponent } from './presentation/blog/blog-creat-post/blog-creat-post.component';
import { BlogActivityComponent } from './presentation/blog/blog-activity/blog-activity.component';
import { FollowerFollowingComponent } from './presentation/blog/follower-following/follower-following.component';
import { EditBlockUsersComponent } from './presentation/blog/edit-block-users/edit-block-users.component';
import { SimplePopupComponent } from './presentation/blog/simple-popup/simple-popup.component';
import { BlockPopupComponent } from './presentation/blog/block-popup/block-popup.component';
import { RemovePostPopupComponent } from './presentation/blog/remove-post-popup/remove-post-popup.component';
import { SetUsernameBottomsheetComponent } from './presentation/blog/set-username-bottomsheet/set-username-bottomsheet.component';
import { BlogFollowRequestsComponent } from './presentation/blog/blog-follow-requests/blog-follow-requests.component';
import { FaqComponent } from './presentation/setting/faq/faq.component';
import { ReportProblemComponent } from './presentation/setting/report-problem/report-problem.component';
import { PersonalInfoComponent } from './presentation/setting/personal-info/personal-info.component';
import { TribuneSettingComponent } from './presentation/setting/tribune-setting/tribune-setting.component';
import { ExitCreatePostPopupComponent } from './presentation/blog/exit-create-post-popup/exit-create-post-popup.component';
import { ProfileCurrentDietChartComponent } from './presentation/profile/profile-current-diet-chart/profile-current-diet-chart.component';
import { MealDetailBackDialogComponent } from './presentation/plan/meal-detail-back-dialog/meal-detail-back-dialog.component';
import { DialogShared } from './presentation/general/shared/dialog-shared';
import { DietPersonalTypeComponent } from './presentation/generate/diet-personal-type/diet-personal-type.component';
import { ReferralCodeComponent } from './presentation/authentication/components/referral-code/referral-code.component';
import { ReferralDialogComponent } from './presentation/plan/referral-dialog/referral-dialog.component';
import { ReferralComponent } from './presentation/profile/referral/referral.component';
import { PredefinedDietDialogComponent } from './presentation/plan/predefined-diet-dialog/predefined-diet-dialog.component';
import { SupportPageComponent } from './presentation/setting/support-page/support-page.component';
import { RecipeComponent } from './presentation/recipe/recipe.component';
import { RecipeCategoryComponent } from './presentation/recipe/recipe-category/recipe-category.component';
import { RecipeDetailComponent } from './presentation/recipe/recipe-detail/recipe-detail.component';
import { RecipeDetailBottomsheetComponent } from './presentation/recipe/recipe-detail-bottomsheet/recipe-detail-bottomsheet.component';
import { BookmarkedRecipesComponent } from './presentation/recipe/bookmarked-recipes/bookmarked-recipes.component';
import { PlanOverviewComponent } from './presentation/plan/plan-overview/plan-overview.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ShopRewardDialogComponent } from './presentation/shop/shop-reward-dialog/shop-reward-dialog.component';
import { PromotionComponent } from './presentation/register/register/promotion/promotion.component';
import { DeeplinkComponent } from './presentation/main/deeplink/deeplink.component';
import { EditPhonenumberComponent } from './presentation/setting/edit-phonenumber/edit-phonenumber.component';
import { AnswerPageComponent } from './presentation/setting/answer-page/answer-page.component';
import { SupportBottomsheetComponent } from './presentation/setting/support-bottomsheet/support-bottomsheet.component';
import { MessageComponent } from './presentation/setting/message/message.component';
import { MessageInboxComponent } from './presentation/setting/message-inbox/message-inbox.component';
import { MessagePageComponent } from './presentation/setting/message-page/message-page.component';
import { PlansComponent } from './presentation/plans/plans.component';
import { DietTypeOverviewComponent } from './presentation/plans/diet-type-overview/diet-type-overview.component';
import { FastingDaysComponent } from './presentation/authentication/components/fasting-days/fasting-days.component';
import { IosNewBottomsheetComponent } from './presentation/general/ios-new-bottomsheet/ios-new-bottomsheet.component';
import { PlanStatusFastingChartComponent } from './presentation/plan/plan-status-fasting-chart/plan-status-fasting-chart.component';
import { PlanOverviewFastingChartComponent } from './presentation/plan/plan-overview-fasting-chart/plan-overview-fasting-chart.component';
import { EditFastingStartTimeBottomsheetComponent } from './presentation/plan/edit-fasting-start-time-bottomsheet/edit-fasting-start-time-bottomsheet.component';
import { TimeHelper } from './utils/time-helper';
import { CalorieCalculator } from './utils/calorie-calculator';
import { LoadingSpinnerComponent } from './presentation/general/loading-spinner/loading-spinner.component';
import { TermsofuseComponent } from './presentation/authentication/termsofuse/termsofuse.component';

import { PromotionpopupComponent } from './presentation/main/promotionpopup/promotionpopup.component';
import { PlanOverviewBottomsheetComponent } from './presentation/plan/plan-overview-bottomsheet/plan-overview-bottomsheet.component';
import { MainPersonalComponent } from './presentation/plan/personal-package/main-personal/main-personal.component';
import { AddPersonalComponent } from './presentation/plan/personal-package/add-personal/add-personal.component';
import { AddPersonalPackageComponent } from './presentation/plan/personal-package/add-personal-package/add-personal-package.component';
import { CreatePersonalFoodComponent } from './presentation/plan/personal-package/create-personal-food/create-personal-food.component';
import { ExerciseTableComponent } from './presentation/plan/log-exercise/exercise-table/exercise-table.component';
import { ExerciseMainComponent } from './presentation/plan/log-exercise/exercise-main/exercise-main.component';
import { ExercisesComponent } from './presentation/plan/log-exercise/exercises/exercises.component';
import { BlogUserBanPopupComponent } from './presentation/blog/blog-user-ban-popup/blog-user-ban-popup.component';
import { PersonalBottomsheetComponent } from './presentation/plan/personal-package/personal-bottomsheet/personal-bottomsheet.component';
import { PersonalPackageSearchComponent } from './presentation/plan/personal-package/personal-package-search/personal-package-search.component';
import { CreatePersonalPackageComponent } from './presentation/plan/personal-package/create-personal-package/create-personal-package.component';
import { BlogDataService } from './data/repository/blog-repository/blog-data.service';
import { PlanOverviewNotifComponent } from './presentation/plan/plan-overview/plan-overview-notif/plan-overview-notif.component';
import { CommonModule } from '@angular/common';
import * as Hammer from 'hammerjs';

import {
  ApmErrorHandler,
  ApmModule,
  ApmService,
} from '@elastic/apm-rum-angular';
import { appVersion } from './global-variables';
import { GlobalHttpInterceptorService } from './data/repository/error-boundary/http-interceptor.service';
import { CookingStoryComponent } from './presentation/cooking-story/cooking-story.component';
import { CookingStorySliderComponent } from './presentation/cooking-story/cooking-story-slider/cooking-story-slider.component';
import { CookingStorySearchComponent } from './presentation/cooking-story/cooking-story-search/cooking-story-search.component';
import { LottieModule } from 'ngx-lottie';
import { CookingStoryRecipePageComponent } from './presentation/cooking-story/cooking-story-recipe-page/cooking-story-recipe-page.component';
import { CookingStoryTutorialComponent } from './presentation/cooking-story/cooking-story-tutorial/cooking-story-tutorial.component';
import { CookingStoryShowMoreComponent } from './presentation/cooking-story/cooking-story-show-more/cooking-story-show-more.component';
import { CookingStoryFavoriteComponent } from './presentation/cooking-story/cooking-story-favorite/cooking-story-favorite.component';
import { CookingStoryPlayerComponent } from './presentation/cooking-story/cooking-story-player/cooking-story-player.component';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { CookingStoryHomeComponent } from './presentation/cooking-story/cooking-story-home/cooking-story-home.component';
import { CookingStoryPostComponent } from './presentation/cooking-story/cooking-story-post/cooking-story-post.component';
import { CookingStoryKitchenComponent } from './presentation/cooking-story/cooking-story-kitchen/cooking-story-kitchen.component';
import { KitchenComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen/kitchen.component';
import { ShoppinglistComponent } from './presentation/cooking-story/cooking-story-kitchen/shoppinglist/shoppinglist.component';
import { CookingStoryBottomSheetComponent } from './presentation/cooking-story/cooking-story-bottom-sheet/cooking-story-bottom-sheet.component';
import { KitchenQuickBottomsheetComponent } from './presentation/cooking-story/cooking-story-kitchen/shoppinglist/kitchen-quick-bottomsheet/kitchen-quick-bottomsheet.component';
import { ShoppinglistSearchComponent } from './presentation/cooking-story/cooking-story-kitchen/shoppinglist/shoppinglist-search/shoppinglist-search.component';
import { KitchenSearchComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen/kitchen-search/kitchen-search.component';
import { KitchenSearchEditComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen/kitchen-search/kitchen-search-edit/kitchen-search-edit.component';
import { KitchenSearchDateComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen/kitchen-search/kitchen-search-edit/kitchen-search-date/kitchen-search-date.component';
import { KitchenSearchUnitComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen/kitchen-search/kitchen-search-edit/kitchen-search-unit/kitchen-search-unit.component';
import { CookingStoryBottomSheetChangeValueComponent } from './presentation/cooking-story/cooking-story-bottom-sheet/cooking-story-bottom-sheet-change-value/cooking-story-bottom-sheet-change-value.component';
import { CookingStoryBottomSheetChangeUnitComponent } from './presentation/cooking-story/cooking-story-bottom-sheet/cooking-story-bottom-sheet-change-unit/cooking-story-bottom-sheet-change-unit.component';
import { ShoppingListSearchEditComponent } from './presentation/cooking-story/cooking-story-kitchen/shoppinglist/shoppinglist-search/shopping-list-search-edit/shopping-list-search-edit.component';
import { ShoppingListSearchEditUnitComponent } from './presentation/cooking-story/cooking-story-kitchen/shoppinglist/shoppinglist-search/shopping-list-search-edit-unit/shopping-list-search-edit-unit.component';
import { KitcchenQuickAddComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen/kitcchen-quick-add/kitcchen-quick-add.component';
import { CookingStoryMembersComponent } from './presentation/cooking-story/cooking-story-members/cooking-story-members.component';
import { CookingStoryMembersShareComponent } from './presentation/cooking-story/cooking-story-members/cooking-story-members-share/cooking-story-members-share.component';
import { CookingStoryMembersInviteComponent } from './presentation/cooking-story/cooking-story-members/cooking-story-members-invite/cooking-story-members-invite.component';
import { CookingStoryMemberInviteConfirmComponent } from './presentation/cooking-story/cooking-story-members/cooking-story-members-invite/cooking-story-member-invite-confirm/cooking-story-member-invite-confirm.component';
import { CookingStoryMembersEditComponent } from './presentation/cooking-story/cooking-story-members/cooking-story-members-edit/cooking-story-members-edit.component';
import { CookingStoryMembersMembersComponent } from './presentation/cooking-story/cooking-story-members/cooking-story-members-members/cooking-story-members-members.component';
import { CookingStorySuccessMessageComponent } from './presentation/cooking-story/cooking-story-success-message/cooking-story-success-message.component';
import { AppCookingStoryPopupComponent } from './presentation/cooking-story/cooking-story-success-message/app-cooking-story-popup/app-cooking-story-popup.component';
import { ShoppinglistMoveConfirmComponent } from './presentation/cooking-story/cooking-story-kitchen/shoppinglist/shoppinglist-move-confirm/shoppinglist-move-confirm.component';
import { PlanOverviewBottomsheetShowdetailComponent } from './presentation/plan/plan-overview-bottomsheet/plan-overview-bottomsheet-showdetail/plan-overview-bottomsheet-showdetail.component';
import { CookingStoryTutorialKitchenComponent } from './presentation/cooking-story/cooking-story-tutorial-kitchen/cooking-story-tutorial-kitchen.component';
import { KitchenRemoveConfirmComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen-remove-confirm/kitchen-remove-confirm.component';
import { ShopDiscountBottomsheetComponent } from './presentation/shop/shop-discount-bottomsheet/shop-discount-bottomsheet.component';
import { ShopRewardBottomsheetComponent } from './presentation/shop/shop-reward-bottomsheet/shop-reward-bottomsheet.component';
import { StartupService } from './data/repository/startup/startup.service';
export class HammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}
// export function migrationFactory() {
//   // The animal table was added with version 2 but none of the existing tables or data needed
//   // to be modified so a migrator for that version is not included.
//   return {
//     1: (db, transaction) => {
//       const store = transaction.objectStore('diets');
//       store.createIndex('type', 'type', { unique: false });
//     }
//   };
// }
// class MyErrorHandler implements ErrorHandler {
//   constructor() {
//     const that = this;
//     window.console.error = function (err) {
//       that.handleError(err);
//     };
//   }
// async handleError(error) {
//   let err;
//   if (typeof err == 'string') {
//     err = error;
//   } else {
//     err = { ...error };
//   }

//   const data: any = {
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     method: 'POST',
//     body: err,
//   };
//   await fetch('https://dev.bentoapp.org/api/v2/discord', data);
// }
// }

const dbConfig: DBConfig = {
  name: '‌BentoDb',
  version: 8,
  objectStoresMeta: [
    {
      store: 'diets',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        {
          name: 'difficulty',
          keypath: 'difficulty',
          options: { unique: false },
        },
        {
          name: 'isCanceled',
          keypath: 'isCanceled',
          options: { unique: false },
        },
        {
          name: 'hatedFoods',
          keypath: 'hatedFoods',
          options: { unique: false },
        },
        { name: 'diseases', keypath: 'diseases', options: { unique: false } },
        {
          name: 'pregnancyDate',
          keypath: 'pregnancyDate',
          options: { unique: false },
        },
        {
          name: 'breastFeedingDate',
          keypath: 'breastFeedingDate',
          options: { unique: false },
        },
        {
          name: 'specialTypes',
          keypath: 'specialTypes',
          options: { unique: false },
        },
        { name: '_id', keypath: '_id', options: { unique: false } },
        { name: 'days', keypath: 'days', options: { unique: false } },
        {
          name: 'startWeight',
          keypath: 'startWeight',
          options: { unique: false },
        },
        { name: 'activity', keypath: 'activity', options: { unique: false } },
        { name: 'startDate', keypath: 'startDate', options: { unique: false } },
        { name: 'endDate', keypath: 'endDate', options: { unique: false } },
        { name: 'goal', keypath: 'goal', options: { unique: false } },
        { name: 'calorie', keypath: 'calorie', options: { unique: false } },
        { name: 'updatedAt', keypath: 'updatedAt', options: { unique: false } },
        { name: 'createdAt', keypath: 'createdAt', options: { unique: false } },
      ],
    },
    {
      store: 'newDiets',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        {
          name: 'difficulty',
          keypath: 'difficulty',
          options: { unique: false },
        },
        {
          name: 'isCanceled',
          keypath: 'isCanceled',
          options: { unique: false },
        },
        {
          name: 'hatedFoods',
          keypath: 'hatedFoods',
          options: { unique: false },
        },
        { name: 'diseases', keypath: 'diseases', options: { unique: false } },
        {
          name: 'pregnancyDate',
          keypath: 'pregnancyDate',
          options: { unique: false },
        },
        {
          name: 'breastFeedingDate',
          keypath: 'breastFeedingDate',
          options: { unique: false },
        },
        {
          name: 'specialTypes',
          keypath: 'specialTypes',
          options: { unique: false },
        },
        { name: '_id', keypath: '_id', options: { unique: false } },
        { name: 'days', keypath: 'days', options: { unique: false } },
        {
          name: 'startWeight',
          keypath: 'startWeight',
          options: { unique: false },
        },
        { name: 'activity', keypath: 'activity', options: { unique: false } },
        { name: 'startDate', keypath: 'startDate', options: { unique: false } },
        { name: 'endDate', keypath: 'endDate', options: { unique: false } },
        { name: 'goal', keypath: 'goal', options: { unique: false } },
        { name: 'calorie', keypath: 'calorie', options: { unique: false } },
        { name: 'updatedAt', keypath: 'updatedAt', options: { unique: false } },
        { name: 'createdAt', keypath: 'createdAt', options: { unique: false } },
        { name: 'type', keypath: 'type', options: { unique: false } },
        { name: 'fasting', keypath: 'fasting', options: { unique: false } },
      ],
    },
    {
      store: 'foods',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'name', keypath: 'name', options: { unique: false } },
        {
          name: 'primaryFoodUnit',
          keypath: 'primaryFoodUnit',
          options: { unique: false },
        },
        {
          name: 'primaryFoodUnitCalorie',
          keypath: 'primaryFoodUnitCalorie',
          options: { unique: false },
        },
        {
          name: 'foodUnitRatioArray',
          keypath: 'foodUnitRatioArray',
          options: { unique: false },
        },
        { name: 'foodFact', keypath: 'foodFact', options: { unique: false } },
        {
          name: 'foodFactModel',
          keypath: 'foodFactModel',
          options: { unique: false },
        },
        { name: '_id', keypath: '_id', options: { unique: true } },
      ],
    },
    {
      store: 'foodLogs',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'foodLogs', keypath: 'foodLogs', options: { unique: false } },
        { name: 'date', keypath: 'date', options: { unique: true } },
        { name: 'updatedAt', keypath: 'updatedAt', options: { unique: false } },
      ],
    },

    {
      store: 'personalFood',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'foodFact', keypath: 'foodFact', options: { unique: false } },
        { name: 'name', keypath: 'name', options: { unique: false } },
        {
          name: 'primaryFoodUnit',
          keypath: 'primaryFoodUnit',
          options: { unique: false },
        },
        {
          name: 'foodUnitRatioArray',
          keypath: 'foodUnitRatioArray',
          options: { unique: false },
        },
        { name: '_id', keypath: '_id', options: { unique: false } },
      ],
    },
    {
      store: 'personalPackage',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'title', keypath: 'title', options: { unique: false } },
        {
          name: 'foods',
          keypath: 'foods',
          options: { unique: false },
        },
        {
          name: 'user',
          keypath: 'user',
          options: { unique: false },
        },
        { name: '_id', keypath: '_id', options: { unique: false } },
      ],
    },
    {
      store: 'exerciseLogs',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        {
          name: 'exerciseLogs',
          keypath: 'exerciseLogs',
          options: { unique: false },
        },
        { name: 'date', keypath: 'date', options: { unique: true } },
        { name: 'updatedAt', keypath: 'updatedAt', options: { unique: false } },
      ],
    },
    {
      store: 'waterlogs',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'amount', keypath: 'amount', options: { unique: false } },
        { name: 'date', keypath: 'date', options: { unique: false } },
        { name: '_id', keypath: '_id', options: { unique: false } },
      ],
    },
    {
      store: 'weightlogs',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'weight', keypath: 'weight', options: { unique: false } },
        { name: 'date', keypath: 'date', options: { unique: false } },
        { name: '_id', keypath: '_id', options: { unique: false } },
      ],
    },
    {
      store: 'cookingbook',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        {
          name: 'categories',
          keypath: 'categories',
          options: { unique: false },
        },
        {
          name: 'suggestion',
          keypath: 'suggestion',
          options: { unique: false },
        },
        { name: '_id', keypath: '_id', options: { unique: false } },
      ],
    },
    {
      store: 'kitchen',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        {
          name: 'created',
          keypath: 'created',
          options: { unique: false },
        },
        {
          name: 'kitchen',
          keypath: 'kitchen',
          options: { unique: false },
        },
      ],
    },
    {
      store: 'shoppingList',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        {
          name: 'created',
          keypath: 'created',
          options: { unique: false },
        },
        {
          name: 'shoppingList',
          keypath: 'shoppingList',
          options: { unique: false },
        },
      ],
    },
  ],
  // migrationFactory
};

export function playerFactory() {
  return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web');
}
@NgModule({
  declarations: [
    AppComponent,
    IosInstallComponent,
    PhoneRegisterComponent,
    SubmitButtonComponent,
    ActivationCodeComponent,
    RegisterComponent,
    ProgressNavComponent,
    CredentialComponent,
    GenderComponent,
    WeightComponent,
    HeightComponent,
    DietTypeComponent,
    ButtonComponent,
    GenerateComponent,
    ActivityLevelComponent,
    VegetarianComponent,
    RadioButtonComponent,
    DiseaseComponent,
    HatedFoodsComponent,
    DifficultyComponent,
    StartDateComponent,
    DateComponent,
    GenerateOverviewComponent,
    PopupComponent,
    MainComponent,
    PlanComponent,
    BatteryComponent,
    WaterComponent,
    PlanWeightComponent,
    BottomsheetComponent,
    MealsTableComponent,
    CheatDayComponent,
    CalendarComponent,
    MealDetailComponent,
    ChangeMealComponent,
    ProfileComponent,
    DietDetailComponent,
    BarChartComponent,
    PlanStatusComponent,
    ProfileWaterChartComponent,
    ProfileWeightChartComponent,
    LineChartComponent,
    SettingComponent,
    EditBottomsheetComponent,
    EditNameComponent,
    EditGenderComponent,
    EditBirthdateComponent,
    EditHeightComponent,
    EditWeightComponent,
    AboutUsComponent,
    LoadingComponent,
    BlogComponent,
    PostComponent,
    BlogWithTagComponent,
    BlogSearchComponent,
    PostDetailComponent,
    TwoActionPopupComponent,
    ReportBottomsheetComponent,
    BlogProfileComponent,
    IosBottomsheetComponent,
    ShopComponent,
    ShopPurchasePopupComponent,
    ShopDiscountDialogComponent,
    LogoutComponent,
    EditFoodBottomsheetComponent,
    AddFoodComponent,
    AddFoodBottomsheetComponent,
    MealDetailDialogComponent,
    TutorialComponent,
    IntroComponent,
    DailyFoodFactComponent,
    BlogSuggestComponent,
    BlogSettingComponent,
    EditBioComponent,
    EditStatusComponent,
    BlogCreatPostComponent,
    BlogActivityComponent,
    FollowerFollowingComponent,
    EditBlockUsersComponent,
    SimplePopupComponent,
    BlockPopupComponent,
    RemovePostPopupComponent,
    SetUsernameBottomsheetComponent,
    BlogFollowRequestsComponent,
    FaqComponent,
    ReportProblemComponent,
    PersonalInfoComponent,
    TribuneSettingComponent,
    ExitCreatePostPopupComponent,
    ProfileCurrentDietChartComponent,
    MealDetailBackDialogComponent,
    DietPersonalTypeComponent,
    ReferralCodeComponent,
    ReferralDialogComponent,
    ReferralComponent,
    PredefinedDietDialogComponent,
    SupportPageComponent,
    RecipeComponent,
    RecipeCategoryComponent,
    RecipeDetailComponent,
    RecipeDetailBottomsheetComponent,
    BookmarkedRecipesComponent,
    PlanOverviewComponent,
    ShopRewardDialogComponent,
    PromotionComponent,
    DeeplinkComponent,
    EditPhonenumberComponent,
    AnswerPageComponent,
    SupportBottomsheetComponent,
    MessageComponent,
    MessageInboxComponent,
    MessagePageComponent,
    PlansComponent,
    DietTypeOverviewComponent,
    FastingDaysComponent,
    IosNewBottomsheetComponent,
    PlanStatusFastingChartComponent,
    PlanOverviewFastingChartComponent,
    EditFastingStartTimeBottomsheetComponent,
    LoadingSpinnerComponent,
    TermsofuseComponent,
    PromotionpopupComponent,
    BlogUserBanPopupComponent,
    PlanOverviewBottomsheetComponent,
    MainPersonalComponent,
    AddPersonalComponent,
    AddPersonalPackageComponent,
    CreatePersonalFoodComponent,
    PersonalBottomsheetComponent,
    CreatePersonalPackageComponent,
    CreatePersonalPackageComponent,
    ExerciseTableComponent,
    ExerciseMainComponent,
    ExercisesComponent,
    PersonalPackageSearchComponent,
    PlanOverviewNotifComponent,
    CookingStoryComponent,
    CookingStorySliderComponent,
    CookingStorySearchComponent,
    CookingStoryRecipePageComponent,
    CookingStoryTutorialComponent,
    CookingStoryShowMoreComponent,
    CookingStoryFavoriteComponent,
    CookingStoryPlayerComponent,
    CookingStoryHomeComponent,
    CookingStoryPostComponent,
    CookingStoryKitchenComponent,
    KitchenComponent,
    ShoppinglistComponent,
    CookingStoryBottomSheetComponent,
    KitchenQuickBottomsheetComponent,
    ShoppinglistSearchComponent,
    KitchenSearchComponent,
    KitchenSearchEditComponent,
    KitchenSearchDateComponent,
    KitchenSearchUnitComponent,
    CookingStoryBottomSheetChangeValueComponent,
    CookingStoryBottomSheetChangeUnitComponent,
    ShoppingListSearchEditComponent,
    ShoppingListSearchEditUnitComponent,
    KitcchenQuickAddComponent,
    CookingStoryMembersComponent,
    CookingStoryMembersShareComponent,
    CookingStoryMembersInviteComponent,
    CookingStoryMemberInviteConfirmComponent,
    CookingStoryMembersEditComponent,
    CookingStoryMembersMembersComponent,
    CookingStorySuccessMessageComponent,
    AppCookingStoryPopupComponent,
    ShoppinglistMoveConfirmComponent,
    PlanOverviewBottomsheetShowdetailComponent,
    CookingStoryTutorialKitchenComponent,
    KitchenRemoveConfirmComponent,
    ShopDiscountBottomsheetComponent,
    ShopRewardBottomsheetComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    SocialLoginModule,
    NgxSkeletonLoaderModule.forRoot(),
    AppRoutingModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production,
    // }),
    ApmModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ChartsModule,
    ImageCropperModule,
    SwiperModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    HammerModule,
    LottieModule.forRoot({ player: playerFactory }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],

  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
    BlogDataService,
    ProgressNavShared,
    RadioButtonShared,
    SubmitButtonShared,
    RegisterShared,
    ButtonShared,
    PopupShared,
    GenerateShared,
    BottomsheetShared,
    CalendarShared,
    LoadingShared,
    PlanShared,
    MainShared,
    BlogShared,
    ShopShared,
    TutorialShared,
    ProfileShared,
    RecipeShared,
    TabBarShared,
    DialogShared,
    TextHelper,
    DateHelper,
    TimeHelper,
    CalorieCalculator,
    DeviceInfoHelper,
    AuthGuard,
    RouteAnimationShared,
    ApmService,

    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '216970044657-36v67jjq7vtins6tmfu6u4ei51lb9kaq.apps.googleusercontent.com'
            ),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptorService,
      multi: true,
    },
    StartupService,
    {
      provide: APP_INITIALIZER,
      useFactory: (ds: StartupService) => () => ds.started(),
      deps: [StartupService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    let userdata = {
      id: 'Guest',
      name: 'Guest',
      username: 'none',
      email: 'none',
    };
    let user: User = JSON.parse(localStorage.getItem('user'));
    if (user) {
      userdata.id = user._id;
      userdata.name = user.name;
      if (user.email) {
        userdata.email = user.email;
      }
      if (user.username) {
        userdata.username = user.username;
      }
    }

    Sentry.setContext('userdata', userdata);
  }
}
